import * as React from 'react';
import styled from 'styled-components';
import { Col, Row } from 'components/antd';
import * as COLORS from 'constants/colors';
import { DASHBOARD_URL } from 'constants/URL';

const Page404 = ({ location }: any) => {
  return (
    <Wrapper>
      <Row style={{ textAlign: 'center' }}>
        <Logo href={DASHBOARD_URL}>
          <img src="https://s3-ap-southeast-1.amazonaws.com/sourcesage.co/img/ss_logo.png" />
        </Logo>
      </Row>
      <Row style={{ backgroundColor: COLORS.bgGrey }}>
        <Col span={12}>
          <div style={{ margin: '0 10% 0 20%' }}>
            <h1>Oops!</h1>
            <h2>We can't seem to find the page you're looking for.</h2>
            <h3>
              Error code: <span>404</span>
            </h3>
          </div>
        </Col>
        <Col span={12} style={{ height: 'calc(100vh - 60px)' }}>
          <img
            style={{ marginTop: 60, marginLeft: '10%' }}
            src="https://s3.ap-southeast-1.amazonaws.com/sourcesage.co/img/ss_logo_error.png"
          />
        </Col>
      </Row>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  h1 {
    font-size: 160px;
    font-weight: 600;
    color: ${COLORS.textGrey};
  }

  h2 {
    font-size: 36px;
    font-weight: 400;
    color: ${COLORS.textGrey};
  }

  h3 {
    font-size: 18px;
    font-weight: 600;
    color: ${COLORS.textGrey};
  }

  span {
    color: ${COLORS.textRed};
  }
`;

const Logo = styled.a`
  cursor: pointer;
  img {
    height: 60px;
  }
`;

export default Page404;



// WEBPACK FOOTER //
// ./app/containers/404Page.tsx